<script setup lang="ts">
    import { computed } from 'vue'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propOpened: boolean
        propSurveyId: number | null
    }>()

    const emit = defineEmits<{
        (e: 'stop-survey', surveyId: number | null): void
        (e: 'close-dialog'): void
    }>()

    // ---------------- derived ----------------

    const opened = computed(() => props.propOpened)
    const surveyId = computed(() => props.propSurveyId)

    // ---------------- actions ----------------

    function stopSurvey()
    {
        emit('stop-survey', surveyId.value)
    }

    function close()
    {
        emit('close-dialog')
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Closing a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">
                            You're about to close the survey.
                        </p><br />
                    </div>
                    <div class="modal-footer">
                        <button @click="stopSurvey" type="button" class="btn btn-primary">Close the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>